import {
  GET_ALL_IDFC_RECORDS_REQUEST,
  GET_ALL_IDFC_RECORDS_SUCCESS,
  GET_ALL_IDFC_RECORDS_FAIL,
  GET_ALL_IDFC_RECORDS_RESET,

  IMPORT_IDFC_RECORDS_REQUEST,
  IMPORT_IDFC_RECORDS_SUCCESS,
  IMPORT_IDFC_RECORDS_FAIL,
  IMPORT_IDFC_RECORDS_RESET,

  EXPORT_IDFC_RECORDS_REQUEST,
  EXPORT_IDFC_RECORDS_SUCCESS,
  EXPORT_IDFC_RECORDS_FAIL,
  EXPORT_IDFC_RECORDS_RESET,

  UPDATE_IDFC_RECORD_REQUEST,
  UPDATE_IDFC_RECORD_SUCCESS,
  UPDATE_IDFC_RECORD_FAIL,
  UPDATE_IDFC_RECORD_RESET,

  DELETE_IDFC_RECORD_REQUEST,
  DELETE_IDFC_RECORD_SUCCESS,
  DELETE_IDFC_RECORD_FAIL,
  DELETE_IDFC_RECORD_RESET,

  BULK_DELETE_IDFC_RECORDS_REQUEST,
  BULK_DELETE_IDFC_RECORDS_SUCCESS,
  BULK_DELETE_IDFC_RECORDS_FAIL,
  BULK_DELETE_IDFC_RECORDS_RESET,
} from '../constants/idfcConstant';

// Get All IDFC Records Reducer
export const getAllIdfcRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_IDFC_RECORDS_REQUEST:
      return { loadingGetAllIdfcRecords: true };
    case GET_ALL_IDFC_RECORDS_SUCCESS:
      return {
        loadingGetAllIdfcRecords: false,
        getAllIdfcRecordsData: action.payload,
      };
    case GET_ALL_IDFC_RECORDS_FAIL:
      return {
        loadingGetAllIdfcRecords: false,
        errorGetAllIdfcRecords: action.payload,
      };
    case GET_ALL_IDFC_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Import IDFC Records Reducer
export const importIdfcRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_IDFC_RECORDS_REQUEST:
      return { loadingImportIdfcRecords: true };
    case IMPORT_IDFC_RECORDS_SUCCESS:
      return {
        loadingImportIdfcRecords: false,
        importIdfcRecordsData: action.payload,
      };
    case IMPORT_IDFC_RECORDS_FAIL:
      return {
        loadingImportIdfcRecords: false,
        errorImportIdfcRecords: action.payload,
      };
    case IMPORT_IDFC_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};


// Export IDFC Records Reducer
export const exportIdfcRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_IDFC_RECORDS_REQUEST:
      return { loadingExportIdfcRecords: true };
    case EXPORT_IDFC_RECORDS_SUCCESS:
      return {
        loadingExportIdfcRecords: false,
        exportIdfcRecordsData: action.payload,
      };
    case EXPORT_IDFC_RECORDS_FAIL:
      return {
        loadingExportIdfcRecords: false,
        errorExportIdfcRecords: action.payload,
      };
    case EXPORT_IDFC_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};


// Update IDFC Record Reducer
export const updateIdfcRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_IDFC_RECORD_REQUEST:
      return { loadingUpdateIdfcRecord: true };
    case UPDATE_IDFC_RECORD_SUCCESS:
      return {
        loadingUpdateIdfcRecord: false,
        updateIdfcRecordData: action.payload,
      };
    case UPDATE_IDFC_RECORD_FAIL:
      return {
        loadingUpdateIdfcRecord: false,
        errorUpdateIdfcRecord: action.payload,
      };
    case UPDATE_IDFC_RECORD_RESET:
      return {};
    default:
      return state;
  }
};


// Delete IDFC Record Reducer
export const deleteIdfcRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_IDFC_RECORD_REQUEST:
      return { loading: true };
    case DELETE_IDFC_RECORD_SUCCESS:
      return { loading: false, success: true };
    case DELETE_IDFC_RECORD_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_IDFC_RECORD_RESET:
      return {};
    default:
      return state;
  }
};

// Bulk Delete IDFC Records Reducer
export const bulkDeleteIdfcRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_IDFC_RECORDS_REQUEST:
      return { loadingBulkDeleteIdfcRecords: true };
    case BULK_DELETE_IDFC_RECORDS_SUCCESS:
      return {
        loadingBulkDeleteIdfcRecords: false,
        bulkDeleteIdfcRecordsData: action.payload,
      };
    case BULK_DELETE_IDFC_RECORDS_FAIL:
      return {
        loadingBulkDeleteIdfcRecords: false,
        errorBulkDeleteIdfcRecords: action.payload,
      };
    case BULK_DELETE_IDFC_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

